import React from 'react';
import { motion } from 'framer-motion';
import MessageContent from './MessageContent';

const MessageItem = ({ message }) => {
  const isAi = message.role === 'ai';
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className={`flex w-full ${isAi ? 'justify-start' : 'justify-end'} mb-5`}
    >
      {isAi ? (
        <div className="w-full max-w-[92%]">
          <div className="text-[14px] leading-relaxed text-gray-700">
            <MessageContent content={message.content} isAi={true} />
          </div>
        </div>
      ) : (
        <div
          className="max-w-[80%] px-4 py-3 rounded-2xl rounded-br-sm text-[14px] leading-relaxed text-white shadow-md"
          style={{ background: 'linear-gradient(135deg, #6b4f28 0%, #3d2c0f 100%)' }}
        >
          <MessageContent content={message.content} isAi={false} />
        </div>
      )}
    </motion.div>
  );
};

export default MessageItem;